// extracted by extract-css-chunks-webpack-plugin
module.exports = {"zone":"zone-8MRLi","padded":"padded-3uqqL","flexdiv":"flexdiv-24kyt","active":"active-1skR_","accept":"accept-1AaYS","reject":"reject-8cJSw"};